import React from 'react';
import {Link} from "react-router-dom";

const WheelLink = ({children,onClick,...others}) => {
    return <Link {...others} target={'_blank'} onClick={onClick} onAuxClick={onClick}>{children}</Link>
};

export default WheelLink;